var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "V_img_sect_title",
      class: { "video-play-icon": _vm.post.format === 4 },
    },
    [
      _c("a", { attrs: { href: _vm.post.postUrl } }, [
        _c("div", { staticClass: "containerVideoImage img-wrap" }, [
          _c("img", {
            attrs: {
              src: _vm.post.principalImage.url,
              alt: _vm.post.principalImage.alt,
              title: _vm.post.principalImage.title,
            },
          }),
        ]),
      ]),
      _vm._v(" "),
      _vm.post.videoShow
        ? _c("div", { staticClass: "program" }, [
            _c("a", {
              attrs: { href: _vm.post.videoShowUrl },
              domProps: { innerHTML: _vm._s(_vm.post.videoShow) },
            }),
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "kicker", class: _vm.post.section.className }, [
        _c("span", { domProps: { innerHTML: _vm._s(_vm.post.header) } }),
      ]),
      _vm._v(" "),
      _c("h2", { staticClass: "tt" }, [
        _c("a", {
          class: _vm.post.section.className,
          attrs: { href: _vm.post.postUrl },
          domProps: { innerHTML: _vm._s(_vm.post.title) },
        }),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }